
<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Dettaglio Opera" [subTitle]="'Stato: ' + (operaService.operaSession.idStato | anagraficaStatoOpera: (datalist.statoOpera || []))">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="operaDettaglioAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="operaDettaglioAzioni">
                        <button ngbDropdownItem (click)="goBack()">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                        <button ngbDropdownItem (click)="goToModifica()" *ngIf="permessiService.opera['OPERA_EDIT']">
                            <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                            Modifica/Inserisci dati aggiuntivi
                        </button>
                        <button ngbDropdownItem (click)="deleteOpera()" *ngIf="permessiService.opera['OPERA_DELETE']">
                            <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                            Elimina
                        </button>
                        <button ngbDropdownItem (click)="downloadPdf()" *ngIf="operaService.operaSession.idStato === 3">
                            <app-toolkit-bl-icon icon="download" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Scarica PDF
                        </button>
                        <button ngbDropdownItem (click)="ripristinaInBozza()" *ngIf="operaService.operaSession.idStato === 3">
                            <app-toolkit-bl-icon icon="arrow-right" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                            Ripristina in Bozza
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <div class="container-fluid mb-5">
                <div class="row">
                    <div class="col-3" *ngIf="permessiService.opera['OPERA_WORKFLOW_NEXT']">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Avvia processo</h5>
                                <p class="card-text">Avvia processo di passaggio di stato dell'opera.</p>
                                    <div *ngIf="permessiService.opera['OPERA_CHANGE_ALL_STATO']">
                                        <div [formGroup]="formStato" class="form-group">
                                            <label for="stato">Stato opera</label>
                                            <select class="form-control" formControlName="stato" id="stato">
                                                <option *ngFor="let item of statoOperaSelect" [ngValue]="item.id">{{ item.descrizione }}</option>
                                            </select>
                                        </div>
                                    </div>
                                <button type="button" class="btn btn-sm btn-primary" (click)="workflowNext()">Avvia</button>
                            </div>
                        </div>
                    </div>
                    <!-- TODO: da completare -->
                    <!-- <div class="col-3" *ngIf="permessiService.opera['OPERA_EXPORT_SINTESI_OPERA']">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Esporta sintesi opera</h5>
                                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button type="button" class="btn btn-sm btn-primary" (click)="export('sintesi_opera')">Esporta</button>
                            </div>
                        </div>
                    </div> -->
                    <!-- TODO: da completare -->
                    <!-- <div class="col-3" *ngIf="permessiService.opera['OPERA_EXPORT_ELABORAZIONE_TERRITORIO']">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Esporta elaborazione territorio</h5>
                                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button type="button" class="btn btn-sm btn-primary" (click)="export('elaborazione_territorio')">Esporta</button>
                            </div>
                        </div>
                    </div> -->
                    <!-- TODO: da completare -->
                    <!-- <div class="col-3" *ngIf="permessiService.opera['OPERA_EXPORT_CONFRONTO_SOGGETTI_TERRITORIALI']">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Esporta confronto soggetti territoriali</h5>
                                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <button type="button" class="btn btn-sm btn-primary" (click)="export('confronto_soggetti_territoriali')">Esporta</button>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
                <ngb-panel id="tab-1" title="Progetto" *ngIf="operaService.operaSession.tipoInserimento === 1">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-piano-interventi [canEdit]="false" [formGroup]="criteriaForm" [items]="pianoInterventiList" [datalist]="datalist"></app-toolkit-opera-tab-piano-interventi>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-1" title="Rilievo" *ngIf="operaService.operaSession.tipoInserimento === 2">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-piano-rilievi  [canEdit]="false" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-piano-rilievi>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-2" title="Anagrafica dell'opera">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-anagrafica-opera [canEdit]="false" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-anagrafica-opera>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-3" title="Dati costruttivi dell'opera">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-dati-costruttivi-opera [canEdit]="false" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-opera-tab-dati-costruttivi-opera>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-4" title="Opere secondarie dell'opera">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-opere-secondarie [canEdit]="false" [items]="operaSecondariaList" [datalist]="datalist"></app-toolkit-opera-tab-opere-secondarie>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-5" title="Documenti a corredo">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-documenti [canEdit]="false" [items]="documentoOperaList" [datalist]="datalist"></app-toolkit-opera-tab-documenti>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-6" title="Sopralluoghi">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-sopralluoghi [canEdit]="false" [items]="rilevamentoList" [datalist]="datalist"></app-toolkit-opera-tab-sopralluoghi>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-7" title="Manutenzione">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-manutenzione [canEdit]="false" [items]="manutenzioneList" [datalist]="datalist"></app-toolkit-opera-tab-manutenzione>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-8" title="Monitoraggio">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-monitoraggio [canEdit]="false" [items]="monitoraggioList" [datalist]="datalist"></app-toolkit-opera-tab-monitoraggio>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-9" title="Cartografia">
                    <ng-template ngbPanelContent>
                        <app-toolkit-opera-tab-cartografia (viewerOpened)="viewerOpened($event)" ></app-toolkit-opera-tab-cartografia>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</div>
